import AgentWhatsAppLoginEvent from './AgentWhatsAppLoginEvent';
import AgentWhatsAppLogoffEvent from './AgentWhatsAppLogoffEvent';
import AgentVoiceLoginEvent from './AgentVoiceLoginEvent';
import AgentVoiceLogoffEvent from './AgentVoiceLogoffEvent';
import chat from './chat';

export default {
  AgentWhatsAppLoginEvent,
  AgentWhatsAppLogoffEvent,
  AgentVoiceLoginEvent,
  AgentVoiceLogoffEvent,
  ...chat,
};
